import host from '../host';

function swap(json){
  var ret = {};
  for(let key in json){
    ret[json[key]] = key;
  }
  return ret;
}

function get_closest(index, list){
  if(index < 0){
    index = 0;
  }else if(index >= list.length){
    index = list.length - 1;
  }
  return list[index];
}

export default {
  data(){
    return {
      measurements: null,
      cup_sizes: null,
      band_sizes: null,
      manual_sizes: null,
    }
  },
  async mounted(){
    // FAST WAY
    // let measurements = window.localStorage.getItem('measurements', null);
    // let cup_sizes = window.localStorage.getItem('cup_sizes', null);
    // let band_sizes = window.localStorage.getItem('band_sizes', null);
    // let manual_sizes = window.localStorage.getItem('manual_sizes', null);

    // if (!measurements || !cup_sizes || !band_sizes || !manual_sizes) {
    //   await this.get_sizes();
    // } else {
    //   this.measurements = JSON.parse(measurements);
    //   this.cup_sizes = JSON.parse(cup_sizes);
    //   this.band_sizes = JSON.parse(band_sizes);
    //   this.manual_sizes = JSON.parse(manual_sizes);
    // }

    // SLOW WAY
    await this.get_sizes();
  },
  computed:{
    difference_to_uk_size(){
      let difference_to_uk_size = {};
      if(this.cup_sizes){
        for(let cup_size of this.cup_sizes){
          difference_to_uk_size[parseFloat(cup_size.difference)] = cup_size.uk_cup;
        }
      }
      return difference_to_uk_size;
    },
    difference_to_us_size(){
      let difference_to_us_size = {};
      if(this.cup_sizes){
        for(let cup_size of this.cup_sizes){
          difference_to_us_size[parseFloat(cup_size.difference)] = cup_size.us_cup;
        }
      }
      return difference_to_us_size;
    },
    measure_to_size(){
      let measure_to_size = {};
      if(this.band_sizes){
        for(let band_size of this.band_sizes){
          measure_to_size[parseFloat(band_size.minimum_measured)] = band_size.band;
        }
      }
      return measure_to_size;
    },
    sorted_uk_cup_sizes(){
      let cups = [];
      for(let key of Object.keys(this.difference_to_uk_size).sort((a, b) => parseFloat(a) - parseFloat(b))){
        cups.push(this.difference_to_uk_size[String(key)]);
      }
      return cups;
    },
    sorted_us_cup_sizes(){
      let cups = [];
      for(let key of Object.keys(this.difference_to_us_size).sort((a, b) => parseFloat(a) - parseFloat(b))){
        cups.push(this.difference_to_us_size[String(key)]);
      }
      return cups;
    },
  },
  methods: {
    async get_sizes() {
      // let measurements_response = await fetch(host + `/api/measurements/get_all_sizing/`);
      let cup_sizes_response = await fetch(host + `/api/cup_sizes/`);
      // let band_sizes_response = await fetch(host + `/api/band_sizes/`);
      // let manual_sizes_response = await fetch(host + `/api/manual_sizes/`);
      // this.measurements = await measurements_response.json();
      this.cup_sizes = await cup_sizes_response.json();
      // this.band_sizes = await band_sizes_response.json();
      // this.manual_sizes = await manual_sizes_response.json();

      // ADD ONCE FAST WAY
      // window.localStorage.setItem('measurements', JSON.stringify(this.measurements));
      window.localStorage.setItem('cup_sizes', JSON.stringify(this.cup_sizes));
      // window.localStorage.setItem('band_sizes', JSON.stringify(this.band_sizes));
      // window.localStorage.setItem('manual_sizes', JSON.stringify(this.manual_sizes));
    },
    new_uk_measurements(shape, band, cup, fit){
      if(this.measurements && shape && band && cup && fit){
        try {
          let measurement = this.measurements[shape][band][cup];
          let result = null;
          if(fit === 'normal'){
            result = measurement['recommended_size'];
          }
          else if(fit === 'tight'){
            result = measurement['tight_recommended_size'];
          }
          else if(fit === 'loose'){
            result = measurement['loose_recommended_size'];
          }
          if(result){
            return result;
          } else {
            throw `No match in api for: ${shape} ${band} ${cup} ${fit}`;
          }
        }
        catch(err) {
          console.warn(err);
          return this.legacy_uk_size({
            band_measure: band,
            cup_measure: cup,
            fit: fit,
          });
        }
      }
    },
    legacy_uk_size({band_measure = null, cup_measure = null, fit = 'normal',}){
      band_measure = parseFloat(band_measure);
      cup_measure = parseFloat(cup_measure);
      if(this.manual_sizes){
        let manual_size = this.manual_sizes.find(
          manual_size =>
            parseFloat(manual_size.band_size) === band_measure
            && parseFloat(manual_size.cup_size) === cup_measure
        );
        if(manual_size){
          let uk_size = manual_size.uk_sizes.find(uk_size => uk_size.fit === fit);
          if(uk_size){
            return uk_size.size;
          }
          let us_size = manual_size.us_sizes.find(us_size => us_size.fit === fit);
          if(us_size){
            return this.uk_from_us(us_size.size);
          }
        }
      }
      if((fit === 'tight') || (fit === 'loose')){
        let uk_size = this.legacy_uk_size({
          band_measure,
          cup_measure,
          fit: 'normal',
        });
        if(uk_size){
          if(fit === 'tight'){
            return this.tighter_uk_size(uk_size);
          }
          if(fit === 'loose'){
            return this.looser_uk_size(uk_size);
          }
        }
      } else {
        let calculated_band_size = this.underbust_to_band_size(band_measure);
        let difference = cup_measure - band_measure;
        let uk_cup_size = this.uk_cup_size_from_difference(difference);
        if(calculated_band_size && uk_cup_size){
          return `${calculated_band_size}${uk_cup_size}`;
        }
      }
    },
    uk_cup_size_from_difference(difference){
      return this.difference_to_uk_size[Math.floor(difference) || 0.5];
    },
    us_cup_size_from_difference(difference){
      return this.difference_to_us_size[Math.floor(difference) || 0.5];
    },
    get_band_size(size){
      return size.slice(0, 2);
    },
    get_cup_size(size){
      return size.slice(2);
    },
    tighter_uk_size(uk_size){
      let old_band_size = this.get_band_size(uk_size);
      let uk_cup_size = this.get_cup_size(uk_size);
      let new_band_size = this.band_size_adjustment(old_band_size, -1);
      let new_cup_size = this.cup_size_adjustment(uk_cup_size, 1);
      return this.size_if_valid_change(old_band_size, uk_cup_size, new_band_size, new_cup_size);
    },
    looser_uk_size(uk_size){
      let old_band_size = this.get_band_size(uk_size);
      let uk_cup_size = this.get_cup_size(uk_size);
      let new_band_size = this.band_size_adjustment(old_band_size, 1);
      let new_cup_size = this.cup_size_adjustment(uk_cup_size, -1);
      return this.size_if_valid_change(old_band_size, uk_cup_size, new_band_size, new_cup_size);
    },
    size_if_valid_change(old_band_size, uk_cup_size, new_band_size, new_cup_size){
      if(new_band_size && new_cup_size){
        if((old_band_size != new_band_size) && (uk_cup_size != new_cup_size)){
          return `${new_band_size}${new_cup_size}`;
        }
      }
    },
    band_size_adjustment(band_size, adjustment){
      let current_index = this.band_sizes.findIndex(band => band.band == band_size);
      let new_index = current_index + adjustment;
      return get_closest(new_index, this.band_sizes).band;
    },
    cup_size_adjustment(uk_cup_size, adjustment){
      let current_index = this.cup_sizes.findIndex(cup_size => cup_size.uk_cup == uk_cup_size);
      let new_index = current_index + adjustment;
      return get_closest(new_index, this.cup_sizes).uk_cup;
    },
    uk_from_us(us_size){
      let band = this.get_band_size(us_size);
      let us_cup = this.get_cup_size(us_size);
      let difference = swap(this.difference_to_us_size)[us_cup];
      let uk_cup = this.difference_to_uk_size[difference];
      return band + uk_cup;
    },
    us_from_uk(uk_size){
      if(uk_size){
        let band = this.get_band_size(uk_size);
        let uk_cup = this.get_cup_size(uk_size);
        let difference = swap(this.difference_to_uk_size)[uk_cup];
        let us_cup = this.difference_to_us_size[difference];
        return band + us_cup;
      }
    },
    underbust_to_band_size(measurement){
      // start with widest measure, find first match that is smaller
      for(let key of Object.keys(this.measure_to_size).sort().reverse()){
        if(parseFloat(key) <= parseFloat(measurement)){
          return this.measure_to_size[key];
        }
      }
    },
  },
}
